export default __webpack_public_path__ + "static/media/clouds-background.8181b35e.jpg";